<template>
  <section>
    <div class="item">
      <div class="header">
        <div class="little-title">Coupon Settings</div>
        <div class="btn">
          <v-button
            gray
            :disabled="couponBtnDisabled"
            @click="handleCounponRestore">Restore</v-button>
          <v-button
            green
            :disabled="couponBtnDisabled"
            @click="handleCouponSave">Save</v-button>
        </div>
      </div>
      <el-form
        ref="coupon-form"
        :model="formData.coupon_detail"
        :rules="rules">
        <div class="half-item">
          <div class="form-item flex-column">
            <span class="title"></span>
            <el-form-item class="item-checkbox">
              <v-checkbox
                v-model="formData.coupon_detail.status"
                :isBoolean="false"
                @change="couponStatusChange"></v-checkbox>
            </el-form-item>
          </div>
          <div class="form-item half">
            <span class="title">Coupon Code</span>
            <el-form-item prop="coupon_code">
              <v-input v-model="formData.coupon_detail.coupon_code"></v-input>
            </el-form-item>
          </div>
          <div class="form-item half">
            <span class="title">Time Period</span>
            <el-form-item prop="date">
              <v-date-picker
                v-model="formData.coupon_detail.date"
                type="daterange"></v-date-picker>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <div class="line"></div>

    <!-- <div class="item">
      <div class="header">
        <div class="little-title">Referral Settings</div>
      </div>
      <el-form
        ref="referral-form"
        :model="referralData">
        <div class="form-item half">
          <v-checkbox
            v-model="referralData.code"
            :isBoolean="false">Custom Referral Code</v-checkbox>
        </div>
      </el-form>
    </div>

    <div class="line"></div> -->

    <!-- <div class="item">
      <div class="header">
        <div class="little-title">Custom Discount</div>
      </div>
      <el-form
        ref="custom-form"
        :model="formData.referral_detail">
        <div class="form-item half">
          <v-radio-group
            v-model="formData.referral_detail.discount_type"
            :list="typeList" />
        </div>
      </el-form>
    </div>

    <div
      v-if="formData.referral_detail.discount_type != 0"
      class="line special"></div>

    <div
      v-if="formData.referral_detail.discount_type == 1"
      class="item width50">
      <el-form
        ref="all-insurance"
        class="all-insurance"
        :model="formData.referral_detail">
        <div class="form-container">
          <el-form-item
            :ref="'products.0.amount_type'"
            :rules="rules.amount_type"
            :prop="'products.0.amount_type'">
            <el-radio-group v-model="formData.referral_detail.products[0].amount_type">
              <div class="form-item">
                <el-form-item>
                  <el-radio :label="1">Percentage</el-radio>
                </el-form-item>
              </div>
              <div
                v-if="formData.referral_detail.products[0].amount_type=='1'"
                class="sub-form-item">
                <div class="form-item">
                  <el-form-item
                    :ref="'products.0.amount_percent'"
                    :rules="rules.amount_percent"
                    :prop="'products.0.amount_percent'">
                    <v-input
                      v-model="formData.referral_detail.products[0].amount_percent"
                      keyFloatNumber
                      append="%"/>
                  </el-form-item>
                </div>
                <div class="form-item flex">
                  <v-checkbox
                    v-model="formData.referral_detail.products[0].fixed_maximum_select"
                    class="height20"
                    @change="setMaximum(0, formData.referral_detail.products[0].fixed_maximum_select)">Set fixed maximum</v-checkbox>
                  <el-form-item
                    :ref="'products.0.fixed_maximum'"
                    :rules="rules.fixed_maximum"
                    :prop="'products.0.fixed_maximum'"
                    class="flex1 mg-l-15">
                    <v-input
                      v-model="formData.referral_detail.products[0].fixed_maximum"
                      keyFloatNumber
                      prepend="$"/>
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <el-form-item>
                  <el-radio :label="2">Fixed Amount
                  </el-radio>
                </el-form-item>
              </div>
              <div
                v-if="formData.referral_detail.products[0].amount_type=='2'"
                class="sub-form-item">
                <div class="form-item">
                  <el-form-item
                    :ref="'products.0.fixed_amount'"
                    :rules="rules.fixed_amount"
                    :prop="'products.0.fixed_amount'">
                    <v-input
                      v-model="formData.referral_detail.products[0].fixed_amount"
                      keyFloatNumber
                      prepend="$"/>
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <el-form-item>
                  <el-radio :label="3">Tiers
                  </el-radio>
                </el-form-item>
              </div>
              <div
                v-if="formData.referral_detail.products[0].amount_type=='3'"
                class="sub-form-item">
                <template v-if="formData.referral_detail.products[0].tiers && formData.referral_detail.products[0].tiers.length">
                  <div
                    v-for="(item,index) in formData.referral_detail.products[0].tiers"
                    :key="index"
                    class="form-item flex class-flex pd-b-16">
                    <el-form-item
                      :ref="'products.0.tiers.'+ index +'.limit_amount'"
                      class="flex1"
                      :rules="rules.limit_amount"
                      :prop="'products.0.tiers.'+ index +'.limit_amount'">
                      <v-input
                        v-model="item.limit_amount"
                        keyFloatNumber
                        prepend="≥$"/>
                    </el-form-item>
                    <span>
                      <font-awesome-icon icon="angle-right"></font-awesome-icon>
                    </span>
                    <el-form-item
                      :ref="'products.0.tiers.'+ index +'.discount_amount'"
                      class="flex1"
                      :rules="rules.discount_amount"
                      :prop="'products.0.tiers.'+ index +'.discount_amount'">
                      <v-input
                        v-model="item.discount_amount"
                        keyFloatNumber
                        prepend="-$"/>
                    </el-form-item>
                    <font-awesome-icon
                      v-if="index!=0"
                      icon="trash-alt"
                      class="red-icon"
                      @click="handlerDelTiers($event, 0, index)"></font-awesome-icon>
                  </div>
                </template>
                <v-button
                  v-if="!formData.referral_detail.products[0].tiers || formData.referral_detail.products[0].tiers.length<5"
                  plain
                  class="button-width"
                  @click="handlerAddTiers(0)">Add Tier</v-button>
              </div>
            </el-radio-group>
          </el-form-item>
          <div class="form-item mg-t-8">
            <el-form-item>
              <v-checkbox v-model="formData.referral_detail.products[0].is_limit">Auto-disable after</v-checkbox>
            </el-form-item>
          </div>
          <div
            v-if="formData.referral_detail.products[0].is_limit"
            class="form-item">
            <el-form-item
              :ref="'products.0.use_total'"
              :rules="rules.use_total"
              :prop="'products.0.use_total'">
              <v-input
                v-model="formData.referral_detail.products[0].use_total"
                int
                append="uses"></v-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <div
      v-if="formData.referral_detail.discount_type == 2"
      class="item">
      <el-form
        ref="insurance-form"
        :model="formData.referral_detail"
        :rules="rules">
        <div class="half-item insurance">
          <template v-for="(insurance, i) in formData.referral_detail.products">
            <div
              v-if="i > 0"
              :key="i"
              class="form-item insurance-half">
              <v-checkbox
                v-model="insurance.status"
                :isBoolean="false"
                class="border">
                <div class="name">
                  {{insurance.name}}
                  <div class="times">
                    {{insurance.used_times}} uses
                  </div>
                </div>
                <template
                  v-if="insurance.status == 1">
                  <div class="line mg15"></div>
                  <div class="form-container">
                    <el-form-item
                      :ref="'products.'+ i +'.amount_type'"
                      :rules="rules.amount_type"
                      :prop="'products.'+ i +'.amount_type'">
                      <el-radio-group v-model="insurance.amount_type">
                        <div class="form-item">
                          <el-form-item>
                            <el-radio :label="1">Percentage</el-radio>
                          </el-form-item>
                        </div>
                        <div
                          v-if="insurance.amount_type=='1'"
                          class="sub-form-item">
                          <div class="form-item">
                            <el-form-item
                              :ref="'products.'+ i +'.amount_percent'"
                              :rules="rules.amount_percent"
                              :prop="'products.'+ i +'.amount_percent'">
                              <v-input
                                v-model="insurance.amount_percent"
                                keyFloatNumber
                                append="%"/>
                            </el-form-item>
                          </div>
                          <div class="form-item flex">
                            <v-checkbox
                              v-model="insurance.fixed_maximum_select"
                              class="height20"
                              @change="setMaximum(i, insurance.fixed_maximum_select)">Set fixed maximum</v-checkbox>
                            <el-form-item
                              :ref="'products.'+ i +'.fixed_maximum'"
                              :rules="rules.fixed_maximum"
                              :prop="'products.'+ i +'.fixed_maximum'"
                              class="flex1 mg-l-15">
                              <v-input
                                v-model="insurance.fixed_maximum"
                                keyFloatNumber
                                prepend="$"/>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="form-item">
                          <el-form-item>
                            <el-radio :label="2">Fixed Amount
                            </el-radio>
                          </el-form-item>
                        </div>
                        <div
                          v-if="insurance.amount_type=='2'"
                          class="sub-form-item">
                          <div class="form-item">
                            <el-form-item
                              :ref="'products.'+ i +'.fixed_amount'"
                              :rules="rules.fixed_amount"
                              :prop="'products.'+ i +'.fixed_amount'">
                              <v-input
                                v-model="insurance.fixed_amount"
                                keyFloatNumber
                                prepend="$"/>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="form-item">
                          <el-form-item>
                            <el-radio :label="3">Tiers
                            </el-radio>
                          </el-form-item>
                        </div>
                        <div
                          v-if="insurance.amount_type=='3'"
                          class="sub-form-item">
                          <template v-if="insurance.tiers && insurance.tiers.length">
                            <div
                              v-for="(item,index) in insurance.tiers"
                              :key="index"
                              class="form-item flex class-flex pd-b-16">
                              <el-form-item
                                :ref="'products.'+ i +'.tiers.'+ index +'.limit_amount'"
                                class="flex1"
                                :rules="rules.limit_amount"
                                :prop="'products.'+ i +'.tiers.'+ index +'.limit_amount'">
                                <v-input
                                  v-model="item.limit_amount"
                                  keyFloatNumber
                                  prepend="≥$"/>
                              </el-form-item>
                              <span>
                                <font-awesome-icon icon="angle-right"></font-awesome-icon>
                              </span>
                              <el-form-item
                                :ref="'products.'+ i +'.tiers.'+ index +'.discount_amount'"
                                class="flex1"
                                :rules="rules.discount_amount"
                                :prop="'products.'+ i +'.tiers.'+ index +'.discount_amount'">
                                <v-input
                                  v-model="item.discount_amount"
                                  keyFloatNumber
                                  prepend="-$"/>
                              </el-form-item>
                              <font-awesome-icon
                                v-if="index!=0"
                                icon="trash-alt"
                                class="red-icon"
                                @click="handlerDelTiers($event, i, index)"></font-awesome-icon>
                            </div>
                          </template>
                          <v-button
                            v-if="!insurance.tiers || insurance.tiers.length<5"
                            class="button-width"
                            gray
                            @click="handlerAddTiers(i)">Add Tier</v-button>
                        </div>
                      </el-radio-group>
                    </el-form-item>
                    <div class="line mg15"></div>
                    <div class="form-item">
                      <el-form-item>
                        <v-checkbox v-model="insurance.is_limit">Auto-disable after</v-checkbox>
                      </el-form-item>
                    </div>
                    <div
                      v-if="insurance.is_limit"
                      class="form-item">
                      <el-form-item
                        :ref="'products.'+ i +'.use_total'"
                        :rules="rules.use_total"
                        :prop="'products.'+ i +'.use_total'">
                        <v-input
                          v-model="insurance.use_total"
                          int
                          append="uses"></v-input>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </v-checkbox>
            </div>
          </template>
        </div>
      </el-form>
    </div> -->

    <div class="item">
      <!--      <div class="item-title">-->
      <!--        <v-checkbox-->
      <!--          v-model="formData.reward_detail.use_new_renew"-->
      <!--          :is-boolean="false">Use same % for both new and renew policy</v-checkbox>-->
      <!--      </div>-->
      <div class="header flex-sb-center">
        <div class="little-title">Setting up referral rewards</div>
        <span class="fs-14">Last update: {{time||'-'}}</span>
      </div>

      <div class="list">
        <div  class="tr">
          <div class="list-item item-title">

          </div>
          <div class="list-item item-title input">
            New Policy
          </div>
          <div class="list-item item-title input">
            Renewal
          </div>
          <div class="list-item item-title input">
            Max
          </div>
        </div>
        <div
          v-for="(item, i) in formData.reward_detail.products"
          :key="i"
          class="tr">
          <div class="list-item item-title">
            {{item.name}}
          </div>
          <!--          <div class="list-item type">-->
          <!--            <v-radio-group-->
          <!--              v-model="item.discount_type"-->
          <!--              :list="typeList"></v-radio-group>-->
          <!--          </div>-->
          <div class="list-item input">
            <!--            <template v-if="item.discount_type == 1">-->
            <!--              <v-input-->
            <!--                v-model="item.discount_str"-->
            <!--                disabled></v-input>-->
            <!--            </template>-->
            <!--            <template v-else>-->
            <!--              <v-select-->
            <!--                v-model="item.reward"-->
            <!--                :list="item.custom_options"></v-select>-->
            <!--            </template>-->
            <template>
              <v-select
                v-model="item.reward"
                :list="item.custom_options"
              ></v-select>
            </template>
          </div>
          <div class="list-item input">
            <v-select
              v-if="item.renew_disable==1"
              :disabled="true"
            ></v-select>
            <v-select
              v-else
              v-model="item.renew_reward"
              :disabled="isDisable||item.renew_disable==1"
              :list="item.custom_options"></v-select>
          </div>
          <div class="list-item input">
            <v-select
              v-model="reward_list[i].max_reward"
              :list="reward_list_options"
              :index="i"
              @change="handleSetMax"></v-select>
          </div>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="btn">
      <v-button
        gray
        :disabled="referralRewardsDisabled"
        @click="handleRewardsRestore">Restore</v-button>
      <v-button
        green
        :disabled="referralRewardsDisabled"
        @click="handleRewardsSave">Save</v-button>
    </div>
  </section>
</template>

<script>
import {referralCouponSave, referralDiscountSave, referralSettingDetail,customerMaxList,setCustomerMaxList} from '@/api/referral'

export default {
  name: '',
  inject:['customer_id'],
  props:{
    time:{
      type:String,
      default:''
    }
  },
  data () {
    const checkCouponRequired = (rule, value, cb) => {
      const valueResult = value == null || value == '' || value.length == 0
      const message = this.$t('placeholder.input')
      const require = this.formData.coupon_detail.status == 1
      if(require && valueResult) {
        cb(new Error(message))
      }
      cb()
    }

    const checkProductRequired = (rule, value, cb) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const valueResult = value == null || value == ''
      const message = this.$t('placeholder.select')
      const require = this.formData.referral_detail.products[index].status == 1
      if(require && valueResult) {
        cb(new Error(message))
      }
      cb()
    }

    const checkMax = (rule, value, cb) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const valueResult = value == null || value == ''
      const message = this.$t('placeholder.input')
      const require = this.formData.referral_detail.products[index].fixed_maximum_select
      if(require && valueResult) {
        cb(new Error(message))
      }
      cb()
    }
    return {
      reward_list: [],
      reward_list_options: [],
      couponBtnDisabled: true,
      referralRewardsDisabled: true,
      // referralData:{
      //   code: 1
      // },
      typeList:[
        {
          name: 'Standard',
          id: 1
        },
        {
          name: 'Custom',
          id: 2
        }
      ],

      formData: {
        coupon_detail:{
          status: 0,
          coupon_code: '',
          date: [],
          start_time: '',
          end_time: ''
        },
        referral_detail:{
          discount_type: 0,
          products: []
        },
        reward_detail:{
          products:[],
          use_new_renew:0
        }
      },
      oldForm: {},
      rules: {
        coupon_code: [
          {validator: checkCouponRequired, trigger: ['change', 'blur']}
        ],
        date: [
          {validator: checkCouponRequired, trigger: ['change', 'blur']}
        ],
        amount_type: [
          {validator: checkProductRequired, trigger: ['change', 'blur']}
        ],
        amount_percent: [
          {required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur']}
        ],
        fixed_maximum: [
          {validator: checkMax, trigger: ['change', 'blur']}
        ],
        fixed_amount: [
          {required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur']}
        ],
        limit_amount: [
          {required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur']}
        ],
        discount_amount: [
          {required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur']}
        ],
        use_total: [
          {required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur']}
        ]
      }
    }
  },
  computed:{
    customerId(){
      return this.customer_id()
    },
    isDisable(){
      return false
      return this.formData.reward_detail.use_new_renew==1
    },
    maxRewardList(){
      return (max)=>{
        return this.reward_list_options
        if(max==-1)
          return this.reward_list_options
        return this.reward_list_options.filter(item=>item.id<=max)
      }
    },
  },
  watch:{
    'formData.coupon_detail.date':{
      deep: true,
      handler(val){
        if(val && val.length > 0){
          this.formData.coupon_detail.start_time = val[0]
          this.formData.coupon_detail.end_time = val[1]
        }else{
          this.formData.coupon_detail.start_time = ''
          this.formData.coupon_detail.end_time = ''
        }
      }
    },
    formData: {
      deep: true,
      handler(val){
        this.couponBtnDisabled =  true
        this.referralRewardsDisabled =  true
        let old_coupon = JSON.stringify(this.oldForm.coupon_detail)
        let newVal_coupon = JSON.stringify(val.coupon_detail)
        let old_referral_rewards = JSON.stringify(this.oldForm.reward_detail)
        let new_referral_rewards = JSON.stringify(val.reward_detail)
        if(old_coupon != newVal_coupon){
          this.couponBtnDisabled =  false
        }
        if(old_referral_rewards != new_referral_rewards){
          this.referralRewardsDisabled =  false
        }
        // let {use_new_renew} = val||{}
        let {products=[],use_new_renew} = val.reward_detail||{}
        // if(use_new_renew==1){
        //   products.filter(item=>{
        //     item.renew_reward = item.reward
        //   })
        // }
      }
    }
  },
  async created(){
    await this.network().customerMaxList()
    await this.network().referralSettingDetail()
  },
  methods: {
    handleSetMax(val,index){
      let {class_id,plan_type,trm_of_cvr} = this.reward_list[index]||{}
      this.network().setCustomerMaxList({
        class_id,
        plan_type,
        trm_of_cvr,
        max_reward:val
      })
    },
    handleCounponRestore(){
      this.formData.coupon_detail = JSON.parse(JSON.stringify(this.oldForm.coupon_detail))
    },
    handleCouponSave(){
      this.$refs['coupon-form'].validate(valid => {
        if(valid){
          let coupon_params = {
            user_id: this.customerId,
            ...this.formData.coupon_detail
          }
          this.network().referralCouponSave(coupon_params)
        }
      })
    },

    handleRewardsRestore(){
      this.formData.reward_detail = JSON.parse(JSON.stringify(this.oldForm.reward_detail))
    },

    handleRewardsSave(){
      let refer_params = {
        user_id: this.customerId,
        ...this.formData.reward_detail
      }
      this.network().referralDiscountSave(refer_params)
      // if(this.formData.referral_detail.discount_type == 1 == 0){
      //   this.network().referralDiscountSave(refer_params)
      // }else if(this.formData.referral_detail.discount_type == 1){
      //   this.$refs['all-insurance'].validate(valid => {
      //     if(valid){
      //       this.network().referralDiscountSave(refer_params)
      //     }
      //   })
      // }else{
      //   this.$refs['insurance-form'].validate(valid => {
      //     if(valid){
      //       this.network().referralDiscountSave(refer_params)
      //     }
      //   })
      // }
    },

    // handlerAddTiers(index){
    //   let data = {
    //     limit_amount:'',
    //     discount_amount:''
    //   }
    //   data = JSON.parse(JSON.stringify(data))
    //   this.formData.referral_detail.products[index].tiers.push(data)
    // },

    // handlerDelTiers(e, prodcut_index, index){
    //   e.preventDefault()
    //   this.formData.referral_detail.products[prodcut_index].tiers.splice(index, 1)
    // },

    couponStatusChange(v){
      // 不勾选的时候清空表单校验
      if(v == 0){
        this.$refs['coupon-form'].clearValidate()
      }
    },

    // setMaximum(index, value){
    //   // 不勾选的时候清空表单校验
    //   if(!value){
    //     if(index == 0){
    //       this.$refs['all-insurance'].clearValidate('products.0.fixed_maximum')
    //     }else{
    //       this.$refs['insurance-form'].clearValidate('products.' + index + '.fixed_maximum')
    //     }
    //   }
    // },

    network(){
      return {
        referralSettingDetail: async () => {
          let params = {
            user_id: this.customerId
          }
          const {data} = await referralSettingDetail(params)
          if(Array.isArray(data.coupon_detail)){
            data.coupon_detail = {
              status: 0,
              coupon_code: '',
              date: [],
              start_time: '',
              end_time: ''
            }
          }
          if(data.coupon_detail.start_time){
            let date = []
            date.push(data.coupon_detail.start_time)
            date.push(data.coupon_detail.end_time)
            data.coupon_detail.date = date
          }
          // 如果tiers没有则默认加上一项
          // data.referral_detail.products.forEach(item => {
          //   if(!item.tiers || item.tiers.length == 0){
          //     let tiers_obj = {
          //       limit_amount:'',
          //       discount_amount:''
          //     }
          //     let tiers_data = JSON.parse(JSON.stringify(tiers_obj))
          //     item.tiers = []
          //     item.tiers.push(tiers_data)
          //   }
          // })
          // data.referral_detail.products[0].status = 1
          this.formData = JSON.parse(JSON.stringify(data))
          this.oldForm = JSON.parse(JSON.stringify(data))
          console.log(this.formData)
        },
        setCustomerMaxList: async (params) => {
          params = {
            user_id: this.customerId,
            ...params
          }
          const {data} = await setCustomerMaxList(params)
          this.network().referralSettingDetail()
        },
        customerMaxList: async () => {

          const {data} = await customerMaxList({user_id:this.customerId})
          this.reward_list = data.reward_list
          this.reward_list_options = data.options
        },

        referralCouponSave: async params => {
          const {data} = await referralCouponSave(params)
          const {code} = data
          if(code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.network().referralSettingDetail()
            this.$emit('update')
          }
        },

        referralDiscountSave: async params => {
          console.log('use_new_renew',params)
          const {data} = await referralDiscountSave(params)
          console.log(data)
          const {code} = data
          if(code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.network().referralSettingDetail()
            this.$emit('update')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.item{
  padding: 0 8px;
  &.width50{
    width: 50%;
  }
  .header{
    display: flex;
    justify-content: space-between;
    .little-title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      height: 24px;
      color: #24292E;
    }
  }
  .el-form{
    margin-top: 20px;
  }
  .half-item{
    display: flex;
    flex-wrap: wrap;
    .half{
      flex: 1;
      & + .half{
        padding-left: 20px;
      }
    }
  }
  .form-item{
    &.flex-column{
      display: flex;
      flex-direction: column;
    }
    padding-bottom: 0;
    .title{
      height: 22px;
    }
    .item-checkbox{
      flex: 1;
      display: flex;
      align-items: center;
      .el-checkbox{
        margin-right: 10px;
      }
    }
  }
  .item-title{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
  }
  .list{
    margin-top: 20px;
    .tr{
      display: flex;
      .list-item{
        display: flex;
        align-items: center;
        & + .list-item{
          margin-left: 20px;
        }
        &.item-title{
          min-width: 280px;
          &.input{
            min-width: auto;
          }
        }
        &.type{
          width: 180px;
        }
        &.input{
          width: 200px;
        }
      }
      & + .tr{
        margin-top: 20px;
      }
    }
  }
  // .insurance{
  //   padding-left: 20px;
  //   .insurance-half{
  //     width: 50%;
  //     margin-top: 18px;
  //     &:nth-child(even){
  //       margin-left: 20px;
  //     }
  //     &:nth-child(odd){
  //       margin-left: -20px;
  //     }
  //   }
  //   /deep/.el-checkbox{
  //     &.border{
  //       border: 1px solid #D1D5DA;
  //       border-radius: 6px;
  //       min-height: 50px;
  //       padding: 18px 15px;
  //       align-items: flex-start !important;
  //     }
  //     .el-checkbox__label{
  //       white-space: normal;
  //       width: 100%;
  //     }
  //     .name{
  //       height: 20px;
  //       line-height: 1;
  //       display: flex;
  //       justify-content: space-between;
  //     }
  //     .times{
  //       color: #6A737D;
  //       font-weight: 400;
  //       font-size: 14px;
  //     }
  //   }
  //   .form-container{
  //     .form-item{
  //       padding-bottom: 8px;
  //     }
  //   }
  // }
  // .all-insurance{
  //   .form-item{
  //     padding-bottom: 8px;
  //   }
  // }
  // .sub-form-item {
  //   margin-left: 20px;
  //   .class-flex{
  //     align-items: center;
  //     span{
  //       margin: 0 10px;
  //     }
  //     .red-icon{
  //       color: #CB2431;
  //       margin-left: 10px;
  //     }
  //   }
  //   .button-width{
  //     width: 100%;
  //     margin-top: 5px;
  //   }
  // }
}
// /deep/.el-radio-group{
//   display: flex;
//   flex-direction: column;
//   height: 90px;
//   width: 124px;
//   .el-radio{
//     height: 30px;
//     line-height: 30px;
//     font-weight: 600;
//     color: #24292E;
//   }
// }
// .el-radio{
//   font-weight: 600;
//   color: #24292E;
// }
// .line.special{
//   margin: 18px 0;
// }
// .line.mg15{
//   margin: 15px 0;
// }
// /deep/.el-checkbox__label{
//   font-weight: 600;
//   color: #24292E;
// }
// .flex1{
//   flex: 1;
// }
// .pd-b-16{
//   padding-bottom: 16px !important;
// }
// .height20{
//   /deep/.el-checkbox__label{
//     height: 20px;
//     line-height: 20px;
//   }
// }
.btn{
  text-align: right;
}
/deep/.el-radio-group{
  .el-radio{
    margin-right: 0 !important;
  }
  .el-radio + .el-radio{
    margin-left: 15px;
  }
}
</style>
